<template>
    <div>

        <Slider :slider="slider" :height="sliderheight">

        </Slider>
        <Blocks :layouts="page.acf.layouts" v-if="page.acf"></Blocks>

    </div>
</template>

<script>
    import Vuex from 'vuex'

    import store from '@/store'

    export default {
        store,
        name: 'Page',
        components: {
            Slider: () => import('@/components/parts/Slider'),
            Blocks: () => import('@/components/parts/Blocks'),
        },
        created() {

            if (this.$route.query.prev) {

                store.dispatch('getPageBySlug', {slug: this.$route.params.slug, type: 'pages', 'id':this.$route.query.id,'nonce': this.$route.query.nonce})
            }
            else store.dispatch('getPageBySlug', {slug: this.$route.params.slug, type: 'pages'})
        },
        watch: {
            $route() {
                if (this.$route.query.prev) {

                    store.dispatch('getPageBySlug', {slug: this.$route.params.slug, type: 'pages', 'id':this.$route.query.id,'nonce': this.$route.query.nonce})
                }
                else store.dispatch('getPageBySlug', {slug: this.$route.params.slug, type: 'pages'})

            }
        },
        computed: {
            page() {
                return store.state.page
            },
            slider() {
                if (store.state.page) {
                    return store.state.page.acf ? store.state.page.acf.bilder : []
                }
                else return []
            },

        }
    }
</script>

<style lang="scss" type="text/scss" scoped>
    .white {

        min-height: 200vh;
    }

    .yellow {
        background-color: yellow;
    }

    h1 {
        color: #fff;
    }
</style>



// WEBPACK FOOTER //
// src/components/endpoints/Page.vue